import { render, staticRenderFns } from "./SnippetNoteForm.vue?vue&type=template&id=861eba94&scoped=true&"
import script from "./SnippetNoteForm.vue?vue&type=script&lang=js&"
export * from "./SnippetNoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861eba94",
  null
  
)

export default component.exports